function cov_1vjbzp0bs1() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/novo/components/index.ts";
  var hash = "d72aba007ba12d244f32afd0298ae841716ae826";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/novo/components/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 32,
          column: 4
        },
        end: {
          line: 59,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "d72aba007ba12d244f32afd0298ae841716ae826"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1vjbzp0bs1 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1vjbzp0bs1();
import accordionListItem from "./accordionListItem.mjs";
import avatar from "./avatar.mjs";
import button from "./button.mjs";
import card from "./card.mjs";
import cardListItem from "./cardListItem.mjs";
import checkbox from "./checkbox.mjs";
import chip from "./chip.mjs";
import form from "./form.mjs";
import formElements from "./formElements.mjs";
import heading from "./heading.mjs";
import image from "./image.mjs";
import input from "./input.mjs";
import label from "./label.mjs";
import link from "./link.mjs";
import list from "./list.mjs";
import listItem from "./listItem.mjs";
import radio from "./radio.mjs";
import tab from "./tab.mjs";
import table from "./table.mjs";
import tableBody from "./tableBody.mjs";
import tableCell from "./tableCell.mjs";
import tableFooter from "./tableFooter.mjs";
import tableHeader from "./tableHeader.mjs";
import tableHeading from "./tableHeading.mjs";
import tableRow from "./tableRow.mjs";
import text from "./text.mjs";
export var components = (cov_1vjbzp0bs1().s[0]++, {
  AccordionListItem: accordionListItem,
  Avatar: avatar,
  Button: button,
  Card: card,
  CardListItem: cardListItem,
  Checkbox: checkbox,
  Chip: chip,
  Form: form,
  Heading: heading,
  Image: image,
  Input: input,
  Label: label,
  Link: link,
  List: list,
  ListItem: listItem,
  Radio: radio,
  FormElements: formElements,
  Tab: tab,
  Table: table,
  TableBody: tableBody,
  TableCell: tableCell,
  TableFooter: tableFooter,
  TableHeading: tableHeading,
  TableHeader: tableHeader,
  TableRow: tableRow,
  Text: text
});